import * as React from 'react';
import cx from 'classnames';

import {
  Building,
  EditLine,
  Email,
  Home,
  Message,
  Mobile,
  Phone,
  Print,
} from '../Icons';

export type ContactCategoryT =
  | 'office'
  | 'mobile'
  | 'home'
  | 'phone'
  | 'fax'
  | 'email'
  | 'message'
  | 'custom';
interface ContactInfoProps {
  /**
   * The value of contact information, could be on mobile, phone and email format.
   */
  value?: string;

  /**
   * The contact category of the contact info. Could be `mobile`, `office`, `phone`, `fax` or `email`
   */
  category?: ContactCategoryT;

  /**
   * The className to customize the style of contact info container
   */
  className?: string;

  /**
   * The height dimension of the contact info icon
   */
  height?: number;

  /**
   * The width dimension of the contact info icon
   */
  width?: number;
}

export default function ContactInfo({
  value = '',
  category = 'phone',
  height = 16,
  width = 16,
  className,
}: ContactInfoProps) {
  return (
    <div
      className={cx(
        'inline-flex align-middle items-center gap-2',
        className && className
      )}
    >
      {category === 'office' ? (
        <Building height={height} width={width} />
      ) : category === 'mobile' ? (
        <Mobile height={height} width={width} />
      ) : category === 'home' ? (
        <Home height={height} width={width} />
      ) : category === 'email' ? (
        <Email height={height} width={width} />
      ) : category === 'fax' ? (
        <Print height={height} width={width} />
      ) : category === 'message' ? (
        <Message height={height} width={width} />
      ) : category === 'custom' ? (
        <EditLine height={height} width={width} />
      ) : (
        <Phone height={height} width={width} />
      )}
      {value && <p className="w-full truncate flex-1">{value}</p>}
    </div>
  );
}
